import { CheckIcon } from '@heroicons/react/24/outline';

interface RadioButtonProps {
  id: string;
  text: string;
  description?: string;
  index: number;
  isChecked: boolean;
  onChange: (value: string) => void;
}

const RadioButton = ({ id, text, description, index, isChecked, onChange }: RadioButtonProps) => {
  return (
    <div>
      <input
        type="radio"
        data-cy={`radio-${id}-${text}`}
        id={`radio-${id}-${index}`}
        name={id}
        className="hidden peer"
        required
        onChange={() => onChange(text)}
      />
      <label
        htmlFor={`radio-${id}-${index}`}
        className="h-full inline-flex items-center w-full p-5 text-darkBlue bg-white border border-darkBlue rounded-lg cursor-pointer peer-checked:bg-darkBlue peer-checked:text-white"
      >
        <div className="w-8 h-8 mr-5 rounded-md border-darkBlue border bg-white flex items-center justify-center shrink-0">
          {isChecked && <CheckIcon className="text-darkBlue h-5 w-5" data-testid={`radio-${id}-${index}-checked`} />}
        </div>
        <div className="block">
          <div className="text-p16 sm:text-p17 lg:text-p20 font-black lg:font-bold">{text}</div>
          <div className="text-p16 sm:text-p17 lg:text-p18">{description}</div>
        </div>
      </label>
    </div>
  );
};

export default RadioButton;
